import React from 'react'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'

import { Section } from '../../components/Section'
import { getAiSearchHowItWorks } from './data'

export function SectionAiSearchHowItWorks() {
  const intl = useIntl()
  const items = getAiSearchHowItWorks(intl)

  return (
    <Section
      containerVerticalPadding={120}
      background="moon-dust-lighter"
      className="position-relative"
    >
      <div
        className={classNames(
          'flexbox flexbox-column flexbox-align-center text-align-center',
          'margin-left-auto margin-right-auto'
        )}
        style={{ maxWidth: 800 }}
      >
        <h2
          className="font-family-title font-size-2 line-height-normal font-weight-medium shade-05"
          style={{ letterSpacing: '-0.02em' }}
        >
          <FormattedMessage
            id="aiSearch.how.title"
            defaultMessage="The most accurate and safe company search out there"
          />
        </h2>
        <p
          className="font-size-4 line-height-large margin-top-16 shade-10"
          style={{ maxWidth: 600 }}
        >
          <FormattedMessage
            id="aiSearch.how.subtitle"
            defaultMessage="Built for retrieval that holds up — with the guardrails enterprise teams need."
          />
        </p>
      </div>

      <div
        className={classNames(
          'grid-12 grid-gap-16 margin-top-40',
          'margin-left-auto margin-right-auto'
        )}
        style={{ maxWidth: 1100 }}
      >
        {items.map((item, idx) => {
          const Icon = item.icon
          return (
            <div
              key={idx}
              className={classNames(
                'grid-span-4-large grid-span-6-medium grid-span-12-small',
                'background-shade-100 radius-larger padding-24'
              )}
              style={{ border: '1px solid var(--alpha-shade-40)' }}
            >
              <div
                className="flexbox flexbox-centered radius-semilarger margin-bottom-16"
                style={{
                  width: 36,
                  height: 36,
                  background: 'var(--alpha-shade-50)',
                }}
              >
                <Icon size={18} className="shade-05" />
              </div>
              <div className="font-size-4 font-family-title font-weight-medium line-height-title shade-05">
                {item.title}
              </div>
              <div className="font-size-6 line-height-large shade-20 margin-top-8">
                {item.desc}
              </div>
            </div>
          )
        })}
      </div>
    </Section>
  )
}
